/**
 * @generated SignedSource<<aba72ab1740db39875d2e9f264ec0cb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoveRewardTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  configId: string;
  rootNodeId: string;
};
export type RewardTreeConfigEditor_RemoveRewardConfigMutation$variables = {
  input: RemoveRewardTreeConfigInput;
};
export type RewardTreeConfigEditor_RemoveRewardConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly removeRewardTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"RewardTreeConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type RewardTreeConfigEditor_RemoveRewardConfigMutation = {
  response: RewardTreeConfigEditor_RemoveRewardConfigMutation$data;
  variables: RewardTreeConfigEditor_RemoveRewardConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RewardTreeConfigEditor_RemoveRewardConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "RemoveRewardTreeConfigPayload",
                "kind": "LinkedField",
                "name": "removeRewardTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RewardTreeConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RewardTreeConfigEditor_RemoveRewardConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "RemoveRewardTreeConfigPayload",
                "kind": "LinkedField",
                "name": "removeRewardTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewardConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "AfterDateTimeDoNotRewardTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b8251fd1e0aac848e1a9ed9b3ef55ae3",
    "id": null,
    "metadata": {},
    "name": "RewardTreeConfigEditor_RemoveRewardConfigMutation",
    "operationKind": "mutation",
    "text": "mutation RewardTreeConfigEditor_RemoveRewardConfigMutation(\n  $input: RemoveRewardTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      removeRewardTreeConfig(input: $input) {\n        rootNode {\n          ...RewardTreeConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment NotAfterDateTimeRewardConfigForm_AfterDateTimeDoNotRewardTreeConfigFragment on AfterDateTimeDoNotRewardTreeConfig {\n  id\n  configType\n  dateTime\n}\n\nfragment NotAfterDateTimeRewardConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment RewardTreeConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      rewardConfigs {\n        __typename\n        id\n        configType\n        ... on AfterDateTimeDoNotRewardTreeConfig {\n          dateTime\n        }\n        ...NotAfterDateTimeRewardConfigForm_AfterDateTimeDoNotRewardTreeConfigFragment\n      }\n    }\n  }\n  ...NotAfterDateTimeRewardConfigForm_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "0b62524dabd2eace53767378cc43410e";

export default node;
